module.exports = __webpack_public_path__ + "static/img/yi3.e68b6cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yi3.png
// module id = /xnP
// module chunks = 0